var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlooddrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3475 8.85284L5.93534 0L0.92025 8.79233C-0.247531 10.6555 -0.349447 13.0781 0.877254 15.0845C2.62096 17.9366 6.37804 18.8522 9.26989 17.1319C12.1607 15.4121 13.0912 11.707 11.3475 8.85284Z",
    fill: "#DA2F47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlooddrop);
export default __webpack_public_path__ + "static/media/blooddrop.3479b475b26a21667d2ba3b679a304be.svg";
export { ForwardRef as ReactComponent };